import React from 'react';
import { Link, graphql } from 'gatsby';

// import Bio from "../components/bio"

import SEO from '../components/seo';
import Navbar from '../components/navbar';
import Newsletter from '../components/newsletter-signup';
import Footer from '../components/footer';

import { rhythm, scale } from '../utils/typography';

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark;
    // const siteTitle = this.props.data.site.siteMetadata.title;
    const { previous, next } = this.props.pageContext;

    return (
      <>
        <SEO title={post.frontmatter.title} description={post.frontmatter.description || post.excerpt} />

        <Navbar></Navbar>

        <article>
          <header className="bgNavPatterned">
            <h1
              style={{
                marginTop: 0,
                paddingTop: rhythm(4),
                marginBottom: 0,
                textAlign: 'center',
                color: '#ddd',
              }}
            >
              {post.frontmatter.title}
            </h1>
            <br />
            <p
              style={{
                ...scale(-1 / 2),
                display: `block`,
                marginBottom: rhythm(1),
                textAlign: 'center',
                color: 'grey',
                fontFamily: 'sans-serif',
                textTransform: 'uppercase',
              }}
            >
              {post.frontmatter.date}
            </p>
            <br />
          </header>
          <div
            style={{
              marginLeft: `auto`,
              marginRight: `auto`,
              maxWidth: rhythm(24),
              padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            }}
          >
            <section dangerouslySetInnerHTML={{ __html: post.html }} />
            <hr
              style={{
                marginBottom: rhythm(1),
              }}
            />
            <footer>{/* <Bio /> */}</footer>
          </div>
        </article>

        <nav>
          <ul
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `center`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  ← {previous.frontmatter.title}
                </Link>
              )}
            </li>
            <li>
              {next && (
                <Link to={next.fields.slug} rel="next">
                  {next.frontmatter.title} →
                </Link>
              )}
            </li>
          </ul>
        </nav>
        <Newsletter />
        <Footer />
      </>
    );
  }
}

export default BlogPostTemplate;

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
    }
  }
`;
